import { useMemo } from 'react';

export function useConstant<TValue>(getValue: () => TValue) {
  // We want to initialize the value, and never change it again
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(getValue, []);
}
